export const DUPLICATE_REQUEST_CANCEL_REASON =
  'duplicate-request-cancel-reason';
